import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';

import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';

import './licenseForm.scss';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';

class AddFacilitiesComponent extends React.Component {
    render() {
        const { handleSubmit, invalid, submitting, handleChange, value } = this.props;

        return <div className='facilities-entry'>
            {submitting && <LoadingComponent fullscreen />}
            <Form onSubmit={handleSubmit}>
                <FieldGroupComponent
                    label={<span>Facility ID <span className='light'>(Separated by commas)</span></span>}
                    name="facilities"
                    type="text"
                    required={false}
                    formProps={{
                        maxLength: 50,
                    }}
                    onChange={handleChange}
                    value={value}
                />
                <Button disabled={invalid} type="submit" className="btn btn-default">Add</Button>
            </Form>
        </div>;
    }
}

AddFacilitiesComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default AddFacilitiesComponent;



// WEBPACK FOOTER //
// ./src/components/profile/License/AddFacilitiesComponent.js